module.exports = __webpack_public_path__ + "img/Presentation37.20abe050.png";